import React from 'react'; // Added React import
import { useLocation, useNavigate } from "react-router-dom";
import "./ApplyFiltersButton.css";

// Receive uiFilters (current UI state) and appliedSearchTitle (from URL)
const ApplyFiltersButton = ({ uiFilters, appliedSearchTitle }) => {
  const navigate = useNavigate();
  const location = useLocation(); // Get current location to preserve other params like sort

  const handleFilterSubmit = () => {
    // Start with current URL parameters to preserve things like 'sort'
    const currentParams = new URLSearchParams(location.search);
    const newFilterParams = new URLSearchParams();

    // 1. Preserve existing search title if there is one
    if (appliedSearchTitle) {
      newFilterParams.set("title", appliedSearchTitle);
    } else {
      // Ensure title is removed if not present in appliedSearchTitle
      // (Shouldn't happen if appliedSearchTitle comes from URL, but good practice)
      currentParams.delete("title");
    }

    // 2. Add filter values from the UI state (uiFilters)
    const categoryId = uiFilters.subcategory || uiFilters.category;
    if (categoryId) {
      newFilterParams.set("categoryId", categoryId);
    }

    // Add price range only if it differs from the default max range
    if (uiFilters.priceRange && (uiFilters.priceRange[0] > 0 || uiFilters.priceRange[1] < 9999999)) {
      newFilterParams.set("minPrice", uiFilters.priceRange[0].toString());
      newFilterParams.set("maxPrice", uiFilters.priceRange[1].toString());
    }

    if (uiFilters.itemCondition && uiFilters.itemCondition.length > 0) {
      newFilterParams.set("itemCondition", uiFilters.itemCondition.join(","));
    }
    
    if (uiFilters.region) {
        newFilterParams.set("region", uiFilters.region);
    }
    if (uiFilters.city) { // Only add city if region is also selected usually
        newFilterParams.set("city", uiFilters.city);
    }
    // Remove city if region is cleared but city remains in uiFilters somehow
    if (!uiFilters.region && newFilterParams.has("city")) {
        newFilterParams.delete("city");
    }

    // 3. Preserve Sort order from current URL
    const currentSort = currentParams.get('sort');
    if (currentSort) {
      newFilterParams.set('sort', currentSort);
    } else {
        newFilterParams.set('sort', 'newest'); // Default sort if not present
    }


    // 4. Reset page number to 1 when applying filters
    newFilterParams.set("page", "1");

    // 5. Navigate to the new URL
    navigate(`/oglasi?${newFilterParams.toString()}`);

    // No need to call setFilters anymore, the navigation + useEffect handle it
  };

  return (
    <button onClick={handleFilterSubmit} className="btn btn-success apply-filters-btn">
      Uporabi filtre <i className="fa-solid fa-filter" />
    </button>
  );
};

export default ApplyFiltersButton; // Ensure default export matches import name